<template>
	<div class="single-page-wrap">
		<article class="weui-article">
			<section>
				<p>请选择要缴费的车牌</p>
			</section>
		</article>
		<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
			<div v-if="plateList.length > 0">
				<div class="weui-cell weui-cell_active weui-cell_access" v-for="item of plateList">
					<div class="weui-cell__bd">
						<span style="vertical-align: middle;">{{item.plateNumber}}</span>
					</div>
					<button class="weui-btn weui-btn_mini weui-btn_default" @click="toPay(item.plateNumber)">缴费</button>
				</div>
			</div>
			<no-data v-else msg="暂无"></no-data>
		</cube-scroll>
		<div class="weui-btn-area">
			<button class="weui-btn weui-btn_primary" @click="handleBindPlate">绑定车牌</button>
		</div>
	</div>

</template>

<script>
	import { getBasicConfig, getParkingPaymentInfo } from "api/coupon/area";
    import { getRecordByPlateNo, order, getParkinglotInfo, pay } from "../../../api/coupon/platePay";
    import { plateList } from "../../../api/coupon/bindPlate";
    import { mapGetters, mapMutations } from 'vuex'

    export default {
        name: "platePay",
		data () {
            return {
                parkinglotId: undefined,
                parkCoupon:0,
                totalPrice: undefined,
                plateNumber: undefined,
                parkRec: undefined,
                plateList: [],
                parkRecInfo: {},
                scrollOptions: {
                    click: true,
                    bounce: false
                },
			}
		},
        computed: {
            ...mapGetters(['userOpenid','keyTopOrderNo'])
        },
        mounted () {
            if (localStorage.getItem('userOpenId')||this.userOpenid ) 
            this.getPlateList();
        },

		methods: {
            ...mapMutations({
                setOrderInfo: "SET_ORDER_INFO",
                setParkrec: "SET_PARKREC",
                setParkingId: "SET_PARKINGLOTID",
                setParkingInfo: "SET_PARKING_INFO",
                setAreaId: 'SET_AREA_ID',
                setKeyTopOrderNo: "SET_KEYTOPORDERNO"
            }),
            getPlateList () {
                console.log(this.userOpenid ,'this.userOpenid ');
              
                plateList({openid: localStorage.getItem('userOpenId')||this.userOpenid}).then(res =>{
                    this.plateList = res.data;
                })
            },
            getParkinglotInfo (id) {
                getParkinglotInfo(id).then(res =>{
                    if (res.code == 200){
                        this.setParkingInfo(res.data)
					}
				})
			},
            getParkingPaymentInfo() {
                let data = {
                    parkinglotId: this.parkinglotId,
                    ts: new Date().getTime(),
                    plateNo: this.plateNumber
                };
                getParkingPaymentInfo(data).then(res =>{
                    console.log(res)
					if (res.code == 200){
                        this.parkFeeToast(res)
					}

                })
            },
            parkFeeToast(res) {
                if (res.code == 200 && res.data) {
                    console.log(res.data,'couponid');
                    this.parkinglotId = res.data.parkinglotId;
                    this.totalPrice = res.data.unpaidMoney;
                    this.parkRec = res.data.id;
                    this.parkRecInfo = res.data;
                    this.setAreaId(res.data.areaId);
                    this.setKeyTopOrderNo(res.data.keyTopOrderNo);
                    this.getParkinglotInfo(res.data.parkinglotId);
                    if (res.data.actualMoney) {
                        this.$weui.alert('请至出口扫码缴费', { title: '提醒' });
                    } else if (this.totalPrice == 0) {
                        this.$weui.alert("&nbsp;&nbsp;&nbsp;&nbsp;车牌为『" + this.plateNumber + "』的车主您好，您需要缴费" +res.data.unpaidMoney +"元，无需支付",
                            { title:"提醒" , });
                    } else {
                        this.showConfirm(res.data.couponid);
                    }
                } else if (res.code == 500) {
                    // 提示当前无车辆出场
                    this.$weui.alert('提醒', { title: '请前往岗亭付费' });
                }
			},
            getRecordByPlateNo(plateNumber) {
                getRecordByPlateNo({plateno: plateNumber}).then(res =>{
                    if (res.code === 200) {
                     
                        this.parkCoupon =res.data.parkCoupon
                     
                        this.parkinglotId = res.data.parkinglotId;
                        getBasicConfig(res.data.areaId).then(res =>{
                            if (res.data.interfaceManner == 2){
                                this.getParkingPaymentInfo()
                            } else {
                                getRecordByPlateNo({plateno: plateNumber}).then(res =>{
                                    this.parkFeeToast(res)
                                })
                            }
                        })
					}

                })
			},
            toPay (plateNumber) {
                this.plateNumber = plateNumber;
                this.getRecordByPlateNo(plateNumber);
			},
            handleBindPlate () {
                localStorage.removeItem("userOpenId")
                this.$router.push({path:'bindPlate',query:{comeFrom:'platePay'}})
            },
            showConfirm(couponid) {
                this.$weui.dialog({
                    title: '提醒',
                    content: "&nbsp;&nbsp;&nbsp;&nbsp;车牌为『" +
                        this.plateNumber +
                        "』的车主您好，您需要缴费" +
                        this.totalPrice +
                        "元",
                    className: 'custom-classname',
                    buttons: [{
                        label: '取消',
                        type: 'default',
                        onClick: () => {

						}
                    }, {
                        label: '去缴费',
                        type: 'primary',
                        onClick: () => {
                            let form ={
                                totalPrice: parseFloat(this.totalPrice).toFixed(2),
                                parkRec: this.parkRec,
                                parkinglotId: this.parkinglotId,
                                goodsType: 3,
                                closed: 0,
                                paymentPlatform: '13',
                                paymentPlatformsn: this.keyTopOrderNo
							};
                            order(form).then(res =>{
                                console.log(res,'res.data');
								if (res.code == 200){
                                    console.log(this.parkRecInfo,'this.parkRecInfo');
                                    this.setParkrec(this.parkRecInfo);
									this.setParkingId(this.parkinglotId);
                                    this.setOrderInfo(res.data);
                               
                                        this.$router.push({ name: "InsideOrder", params:{isEntry: true,} });
								}else {
								    setTimeout(()=>{
                                        this.$weui.alert(res.data.msg, { title: '提示' });
									},300);
								}
							})
						}
                    }]
                });
            },
		}
    }
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';
	.weui-article{
	  padding-top 10px
	  padding-bottom 0
	  section{
		  margin-bottom 0
	  }
	p{
		color $article-merchant-p
		font-size $article-merchant-p
		line-height 20px
	}
	}
	.weui-btn-area{
		margin-top 20px
		.weui-btn{
			width: 100%;
		}
	}
	.cube-scroll{
		position: relative;
		text-align: left;
		white-space: normal;
		max-height: 75%
		overflow hidden
		/*background: #ffffff;*/
		margin-bottom 30px
		.no-data-wrap{
			padding-top 25%
			display flex
			justify-content center
			align-items center
			.weui-article{
				color $no-data-font-color
				h1{
					font-size $no-data-font-size
				}
			}
		}
	}
</style>
